var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('monument-list'),_vm._v(" "),_c('div',{attrs:{"id":"comments"}},[_c('comments-newsfeed'),_vm._v(" "),(_vm.$session.exists()  && _vm.$route.path !=='/')?_c('reported-comments-newsfeed'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3768fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home-Page.vue
// module id = ckXb
// module chunks = 1